import { render } from "./Sns.vue?vue&type=template&id=66a22f5c&scoped=true"
import script from "./Sns.vue?vue&type=script&lang=js"
export * from "./Sns.vue?vue&type=script&lang=js"

import "./Sns.vue?vue&type=style&index=0&id=66a22f5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a22f5c"],['__file',"src/js/components/Sns.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66a22f5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66a22f5c', __exports__)) {
    api.reload('66a22f5c', __exports__)
  }
  
  module.hot.accept("./Sns.vue?vue&type=template&id=66a22f5c&scoped=true", () => {
    api.rerender('66a22f5c', render)
  })

}


export default __exports__